import React from 'react'
import ProgressCard from './ProgressCard'
import Achievements from './Achievements'

const StudentProgess = () => {
  return (
    <>
        <ProgressCard />
        <Achievements />
    </>
  )
}

export default StudentProgess
